import { combinedRoles } from "./constants";
import { ApplicantType } from "shared/types";
import { ActivityItem, ApplicantData, SplitApplicationActivity } from "./types";
import { ApplicantRoleLabel, capitalize, formatToCurrency } from "shared/utils";
import { getFullName } from "shared/utils/get-full-name";

export const getAuthorText = ({
  authorName,
  authorRole
}: {
  authorName?: string;
  authorRole?: string | ApplicantType;
}) => {
  if (!authorName && !authorRole) return "";

  const readableRole = combinedRoles[authorRole || ""];

  if (authorName && readableRole) return `by ${authorName}, ${readableRole}`;

  return `by ${authorName || readableRole}`;
};

export const getActivityMessage = (item: ActivityItem): string | null => {
  if (!item.details || typeof item.details !== "object") return null;

  let nameEmail = "";
  if ("contact" in item.details) {
    const contact = item.details.contact;
    const email = contact?.email ? `(${contact.email})` : "";
    const name = contact
      ? getFullName({
          firstName: contact.first_name,
          lastName: contact.last_name,
          middleName: contact.middle_name
        })
      : "";
    nameEmail = contact ? `${name} ${email}` : "";

    // May need this in the future if we want to include role in the message
    //
    // const contactRole = contact && "role" in contact ? contact.role : undefined;
    // const roleLabel = contactRole ? combinedRoles[contactRole] : "";
    // const article = contactRole === ApplicantType.CoSigner ? "a" : "an";
    // nameRole =
    //   name && roleLabel
    //     ? `${name} (${article} ${roleLabel.toLowerCase()})`
    //     : name || roleLabel;
  }

  switch (item.activity_type) {
    case "canadian_criminal_report_invited":
      return `${nameEmail} was emailed a Canadian criminal background check link`;
    case "decision_email_sent":
      return `${nameEmail} was emailed a decision letter`;
    case "credit_report_sent":
      return `${nameEmail} was emailed a credit report`;
    case "compliance_report_sent":
      return `${nameEmail} was emailed a compliance report`;
    case "placed_on_hold":
    case "resumed":
      return [
        `by ${item.author?.name || "Boom Admin"}`,
        item.author?.author_role
          ? `(${capitalize(
              item.author.author_role.toLowerCase().replace("_", " ")
            )})`
          : ""
      ].join(" ");
    case "submitted":
      if (item.details?.application_fee)
        return `Base application fee (excl. discounts): ${formatToCurrency(
          item.details.application_fee
        )}`;
      return null;
    default:
      return null;
  }
};

export const isTextEmpty = (text: string | undefined): boolean => {
  if (!text) return true;
  return text.trim() === "" || text === "<p></p>";
};

export const getOriginalApplicantsText = (
  application: SplitApplicationActivity
) => {
  const remainingApplicants = application.details.remaining_applicants;
  const movingApplicants = application.details.moving_applicants;
  return getApplicantsText([...remainingApplicants, ...movingApplicants]);
};

export const getApplicantsText = (applicants?: ApplicantData[]) => {
  if (applicants && applicants.length)
    return applicants
      .map((applicant) => {
        const role = ApplicantRoleLabel[applicant.role]
          ? `(${ApplicantRoleLabel[applicant.role]})`
          : "";

        if ("first_name" in applicant)
          return `${getFullName({
            firstName: applicant.first_name,
            lastName: applicant.last_name,
            middleName: applicant.middle_name
          })} ${role}`;
        else return `${applicant.email} ${role}`;
      })
      .join(", ");
  return "";
};
